import type { ReactNode } from 'react';

/** Standard module panel with iconed header + capability tag (design.md components). */
export function Panel({
  id,
  icon,
  title,
  cap,
  why,
  action,
  className,
  children,
}: {
  id?: string;
  icon: ReactNode;
  title: string;
  cap?: string;
  why?: string;
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  return (
    <section id={id} className={`panel${className ? ` ${className}` : ''}`}>
      <div className="panel__head">
        <div className="panel__title-wrap">
          <span className="panel__icon">{icon}</span>
          <div>
            <h2 className="panel__h2">
              {title}
              {cap && <span className="panel__cap">{cap}</span>}
            </h2>
          </div>
        </div>
        {action}
      </div>
      {why && <p className="panel__why">{why}</p>}
      {children}
    </section>
  );
}
